import { Typography } from '@mui/material';
import CustomDialog from '../../../../../../components/dialog/CustomDialog';
import './ResetPasswordConfirmDialog.scss';

export default function ResetPasswordConfirmDialog({ open, onClose, onNext } = {
  open: false,
  onClose: () => { },
  onNext: () => { },
}) {
  return (
    <CustomDialog
      openDialog={open}
      className='reset-password-comfirm-dialog'
      onClose={() => {
        onClose();
      }}
      content={(
        <div className='reset-password-confirm'>
          <Typography variant='h6'>Reset Password</Typography>
          <Typography>Are you sure you want to reset your password?</Typography>
        </div>
      )}
      displayCloseIcon
      actions={[{
        onClick: () => {
          onNext();
        },
        className: 'btn-primary',
        title: 'Next',
      },
      ]}
    />
  );
}
